import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import WorkerPickListAnalysisReportActions from '../../Stores/WorkerPickListAnalysisReport/Actions';

const { Panel } = Collapse;

class WorkerPickListAnalysisReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initWorkerPickListAnalysis } = this.props;

    if (curSiteFlowId > 0) {
      initWorkerPickListAnalysis();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initWorkerPickListAnalysis } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initWorkerPickListAnalysis();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'worker_pick_list_analysis_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

WorkerPickListAnalysisReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initWorkerPickListAnalysis: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

WorkerPickListAnalysisReportScreen.defaultProps = {
  intl: {},
  match: {},

  initWorkerPickListAnalysis: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initWorkerPickListAnalysis: () =>
    dispatch(
      WorkerPickListAnalysisReportActions.workerPickListAnalysisReportInitWorkerPickListAnalysis()
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(WorkerPickListAnalysisReportScreen));
